module.exports = __webpack_public_path__ + "img/one_day_picknic.98669ec9.jpg";